"use client";

import { useState } from "react";
import { TimelineActive as Icon_TimelineActive } from "@/components/customer/icons/TimelineActive";
const SvgIcons = { TimelineActive: Icon_TimelineActive };

type YearKey = "2025" | "2024" | "2023" | "2022";

const YEARS: YearKey[] = ["2025", "2024", "2023", "2022"];

const DATA: Record<
  YearKey,
  { date: string; title: string }[]
> = {
  "2025": [
    { date: "Aug 22th, 2024", title: "Opened Ambattur Tech Office" },
    { date: "Mar 14th, 2019", title: "Opened Kodungiyur Head Office" },
    { date: "Apr 16th, 2015", title: "Founded" },
  ],
  "2024": [
    { date: "Mar 14th, 2019", title: "Opened Kodungiyur Head Office" },
    { date: "Apr 16th, 2015", title: "Founded" },
  ],
  "2023": [{ date: "Apr 16th, 2015", title: "Founded" }],
  "2022": [{ date: "Apr 16th, 2015", title: "Founded" }],
};

export default function TimelineSection() {
  const [activeYear, setActiveYear] = useState<YearKey>("2025");
  const [direction, setDirection] = useState<"left" | "right">("right");
  const [animKey, setAnimKey] = useState(0);

  const setYearWithDirection = (nextYear: YearKey) => {
    if (nextYear === activeYear) return;
    const currentIndex = YEARS.indexOf(activeYear);
    const nextIndex = YEARS.indexOf(nextYear);
    setDirection(nextIndex > currentIndex ? "right" : "left");
    setActiveYear(nextYear);
    setAnimKey((k) => k + 1);
  };

  const goPrev = () => {
    const idx = YEARS.indexOf(activeYear);
    const prev = YEARS[(idx - 1 + YEARS.length) % YEARS.length];
    setYearWithDirection(prev);
  };

  const goNext = () => {
    const idx = YEARS.indexOf(activeYear);
    const next = YEARS[(idx + 1) % YEARS.length];
    setYearWithDirection(next);
  };

  const items = DATA[activeYear];

  const slideClass =
    direction === "right"
      ? "animate-[slideFromRight_0.35s_ease-out]"
      : "animate-[slideFromLeft_0.35s_ease-out]";

  return (
    <>
      <section className="w-full bg-white flex justify-center py-8">
        <div className="w-full max-w-5xl px-4">
          {/* YEAR NAV */}
          <div className="flex items-center justify-center gap-6 mb-6 text-sm font-medium">
            <button
              type="button"
              onClick={goPrev}
              className="text-gray-300 hover:text-gray-400"
            >
              {"<"}
            </button>

            {YEARS.map((year) => {
              const active = year === activeYear;
              return (
                <button
                  key={year}
                  type="button"
                  onClick={() => setYearWithDirection(year)}
                  className={`pb-1 transition-all duration-300 ${active
                    ? "text-[#195AFF] schibsted-grotesk font-[600] text-[18px]"
                    : year === "2022"
                      ? "text-[#000D2D] text-[18px]"
                      : "text-[#090D28] hover:text-[#195AFF] text-[18px]"
                    }`}
                >
                  {year}
                </button>
              );
            })}

            <button
              type="button"
              onClick={goNext}
              className="text-gray-300 hover:text-gray-400"
            >
              {">"}
            </button>
          </div>

          {/* DESKTOP HORIZONTAL */}
          <div className="hidden md:flex relative items-center justify-between mt-4 pt-10">
            <div className="absolute left-0 right-0 top-1/2 bg-gradient-to-r h-[2px] from-transparent via-[#B7C2DD] to-transparent" />

            <div key={animKey} className={`flex w-full justify-between ${slideClass}`}>
              {items.map((item, idx) => (
                <div
                  key={idx}
                  className="relative flex flex-col items-center text-center px-4"
                >
                  <div className="mt-[16px]">
                    <SvgIcons.TimelineActive />
                  </div>
                  <p className="text-[16px] schibsted-grotesk font-semibold text-[#090D28] pt-2">
                    {item.date}
                  </p>
                  <p className="text-[14px] schibsted-grotesk font-medium text-[#000D2D]">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* MOBILE VERTICAL – SAME STYLE */}
          <div className="md:hidden relative mt-6 pl-8">
            {/* vertical line same color */}
            <div className="absolute left-3 top-0 bottom-0 w-[2px] h-[550px] bg-gradient-to-b from-transparent via-[#B7C2DD] to-transparent" />

            <div key={animKey} className={slideClass}>
              {items.map((item, idx) => (
                <div
                  key={idx}
                  className="relative mb-10 flex items-start space-y-[70px]"
                >
                  {/* dot SVG on line */}
                  <div className="absolute -left-[31px] mt-[80px]">
                    <SvgIcons.TimelineActive />
                  </div>

                  <div className="pl-4 ">
                    <p className="text-[16px] schibsted-grotesk font-semibold text-[#090D28] ">
                      {item.date}
                    </p>
                    <p className="text-[14px] schibsted-grotesk font-medium text-[#000D2D]">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* KEYFRAMES */}
        <style jsx>{`
        @keyframes slideFromRight {
          from {
            opacity: 0;
            transform: translateX(32px);
          }
          to {
            opacity: 1;
            transform: translateX(0px);
          }
        }
        @keyframes slideFromLeft {
          from {
            opacity: 0;
            transform: translateX(-32px);
          }
          to {
            opacity: 1;
            transform: translateX(0px);
          }
        }
      `}</style>



      </section>

    </>
  );
}
